import {Entry} from 'contentful';
import {Video} from '../video/video';
import * as moment from 'moment';

export class LiveEvent implements Video {
  thumbnail: string;
  title: string;
  startTime: string;
  location: string;
  id: string;
  live: boolean;
  description?: string;
  createdAt: string;
  featured: boolean;
  planPrice: number;
  planId: string;
  recurring: boolean;
  planTitle: string;
  schools: any[];
  sport: string;
  endpoint: string;
  player: string;
  posterImage: string;
  sponsor: string;
}
export class LiveEventAdapter {

  creatLiveEventFromEntry(entry: Entry<any>) {
    const obj = new LiveEvent();
    obj.id = entry.sys.id;
    obj.title = entry.fields.title;
    obj.live = false;
    obj.startTime = entry.fields.startDate;
    if (moment().isBetween(moment(obj.startTime), moment(obj.startTime).add(3, 'hours'))) {
      obj.live = true;
    }
    obj.createdAt = entry.sys.createdAt;
    obj.description = entry.fields.description;
    if (entry.fields.price) {
      obj.planPrice = entry.fields.price.fields.planPrice;
      obj.planTitle = entry.fields.price.fields.title;
      obj.recurring = entry.fields.price.fields.isRecurringSubscription ? true: false;
      obj.planId = entry.fields.price.fields.stripeId;
    }
    obj.sport = (entry.fields.sport) ? entry.fields.sport.fields.name : null;
    obj.sponsor = (entry.fields.sponsor) ? entry.fields.sponsor.fields.file.url : null;
    obj.posterImage = (entry.fields.posterImage) ? entry.fields.posterImage.fields.file.url : null;
    obj.schools = [];
    if (entry.fields.schools) {
      entry.fields.schools.forEach((school: any) => {
        // @ts-ignore
        // console.log(school);
        if (school.fields) {
          const name = school.fields;
          obj.schools.push(name);
        }
      });
    }
    obj.featured = entry.fields.featured;
    obj.location = entry.fields.location;
    if (entry.fields.liveStreamBox) {
      obj.endpoint = entry.fields.liveStreamBox.fields.endpoint;
    }
    obj.thumbnail = entry.fields.thumbnail ? entry.fields.thumbnail.fields.file.url : '../../assets/img/1Basic_Thumbnail.jpg';
    if (entry.fields.vodStream) {
      obj.live = false;
      obj.endpoint = entry.fields.vodStream;
    }
    return obj;
  }
}
